import * as ScheduleEvents from './scheduleEvents';

export const GTM = { ...ScheduleEvents };
